import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputFieldWrapper, SliderContainer, SliderInput, SliderLabel } from './styles';

const Slider = ({
  id,
  name,
  min = 15,
  max = 300,
  value = 30,
  step = 15,
  onChange,
  tabIndex = 0,
  disabled = false,
  children,
  ...rest
}) => {
  const [currentValue, setCurrentValue] = useState(value);
  const onChangeHandler = (ev) => {
    setCurrentValue(ev.target.value);
  };
  const onMouseUp = () => {
    onChange(currentValue);
  };

  return (
    <InputFieldWrapper>
      <SliderContainer tabIndex={tabIndex} htmlFor={id || name} disabled={disabled}>
        <SliderLabel>{children}:</SliderLabel>
        <SliderInput
          key={`${id}_${value}`}
          type="range"
          min={min}
          max={max}
          value={currentValue}
          step={step}
          name={name || id}
          id={id || name}
          onChange={onChangeHandler}
          onMouseUp={onMouseUp}
          disabled={disabled}
          {...rest}
        />
      </SliderContainer>
    </InputFieldWrapper>
  );
};

Slider.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  rest: PropTypes.object,
};

export default Slider;
